import { type FC, useEffect } from 'react';
import { TooltipSpanWrapper as TooltipTriggerWrapper } from 'src/components/common/Tooltip/TooltipTriggerWrapper';
import VerifiedTag from './VerifiedTag';
import { intercomMessageKeys } from './IntercomMessageKeys';
import { updateIntercomMarkDataAttributeTrue } from 'src/modules/intercom';
import { sendHotjarTag } from 'src/utils/hotjar';
import { HOTJAR_CERTSY_SKILLS_VIEWED } from 'src/constants/hotjar';
import { CertsyToolTip } from 'src/components/common/Certsy/CertsyTooltip/CertsyTooltip';
import VerificationTooltipContent from './VerificationTooltipContent';
import type { RegularOrSmall, Verification } from '../types';
interface Props {
  verifications: Verification[];
  jobApplicationId: string;
  answerText: string;
  isCardView: boolean;
  size?: RegularOrSmall;
}
const VerifiedAssessment: FC<Props> = ({
  verifications,
  jobApplicationId,
  answerText,
  isCardView,
  size,
}) => {
  const hasSeenCertsyAssessments = 'has_seen_certsy_assessments';

  useEffect(() => {
    if (!intercomMessageKeys[hasSeenCertsyAssessments]) {
      intercomMessageKeys[hasSeenCertsyAssessments] = true;
      updateIntercomMarkDataAttributeTrue(hasSeenCertsyAssessments);
      sendHotjarTag(HOTJAR_CERTSY_SKILLS_VIEWED);
    }
  }, []);

  if (verifications.length === 0 || !isCardView) {
    return <VerifiedTag size={size}>{answerText}</VerifiedTag>;
  }
  return (
    <CertsyToolTip
      tooltipContent={
        <VerificationTooltipContent
          jobApplicationId={jobApplicationId}
          verifications={verifications}
        />
      }
      placement="bottom-start"
      offset={[0, 5]}
      fallbackPlacements={['top-start', 'bottom-start']}
    >
      <TooltipTriggerWrapper>
        <VerifiedTag>{answerText}</VerifiedTag>
      </TooltipTriggerWrapper>
    </CertsyToolTip>
  );
};

export default VerifiedAssessment;
